<template>
	<div>
		<div class="friend-item" :class="itemClass" @contextmenu.prevent="showRightMenu($event)">
			<div class="friend-avatar">
				<head-image :size="headImageSize" :name="friend.showNickName" :url="friend.headImage"
					:online="friend.online">
				</head-image>
			</div>
			<div class="friend-info">
				<div class="friend-name">
					<div class="friend-name-text" :title="friend.showNickName">{{ friend.showNickName }}</div>
				</div>
			</div>
			<slot></slot>
		</div>
		<right-menu v-if="menu" ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from "../common/RightMenu.vue";

export default {
	name: "frinedItem",
	components: {
		HeadImage,
		RightMenu
	},
	props: {
		active: {
			type: Boolean
		},
		friend: {
			type: Object
		},
		menu: {
			type: Boolean,
			default: true
		},
		size: {
			type: String,
			default: 'normal'
		}
	},
	methods: {
		showRightMenu(e) {
			if (this.menu && this.$refs.rightMenu) {
				this.$refs.rightMenu.open(e, this.menuItems);
			}
		},
		onSelectMenu(item) {
			if (item && item.action === 'move-group') {
				this.$emit('move-group', item);
				return;
			}
			this.$emit(item.key.toLowerCase(), this.friend);
		}
	},
	computed: {
		headImageSize() {
			if (this.size == 'small') {
				return 34;
			}
			return 42;
		},
		itemClass() {
			let clz = "";
			if (this.active) {
				clz += "active"
			}
			if (this.size == 'small') {
				clz += " small"
			}
			return clz;
		},
		currentGroup() {
			if (!this.friend || !this.friend.id) {
				return null;
			}
			return this.friendGroupStore.findGroupByFriendId(this.friend.id);
		},
		moveGroupMenuItem() {
			const groups = Array.isArray(this.friendGroupStore.groups) ? this.friendGroupStore.groups : [];
			const currentGroupId = this.currentGroup && this.currentGroup.id ? this.currentGroup.id : null;
			if (!currentGroupId && groups.length === 0) {
				return {
					key: 'MOVE_GROUP',
					name: '移动到分组',
					icon: 'el-icon-folder-opened',
					disabled: true
				};
			}
			const children = [{
				key: 'MOVE_GROUP_NONE',
				name: currentGroupId ? '我的好友' : '我的好友（当前）',
				icon: 'el-icon-remove-outline',
				action: 'move-group',
				groupId: null,
				disabled: !currentGroupId
			}];
			groups.forEach((group) => {
				if (!group || !group.id) {
					return;
				}
				children.push({
					key: `MOVE_GROUP_${group.id}`,
					name: currentGroupId === group.id ? `${group.name}（当前）` : group.name,
					icon: 'el-icon-folder',
					action: 'move-group',
					groupId: group.id,
					disabled: currentGroupId === group.id
				});
			});
			return {
				key: 'MOVE_GROUP',
				name: '移动到分组',
				icon: 'el-icon-folder-opened',
				children
			};
		},
		canForwardCard() {
			return this.$permission.canForwardCardMessage
				? this.$permission.canForwardCardMessage()
				: this.$permission.hasRolePermission('message.cardForward');
		},
		menuItems() {
			const items = [{
				key: 'CHAT',
				name: '发送消息',
				icon: 'el-icon-chat-dot-round'
			}];
			if (this.canForwardCard) {
				items.push({
					key: 'CARD',
					name: '分享名片',
					icon: 'el-icon-share'
				});
			}
			items.push(this.moveGroupMenuItem, {
				key: 'DELETE',
				name: '删除好友',
				icon: 'el-icon-delete',
				danger: true
			});
			return items;
		}
	}
}
</script>

<style scope lang="scss">
.friend-item {
	height: 62px;
	display: flex;
	position: relative;
	align-items: center;
	white-space: nowrap;
	border-radius: 0;
	margin: 0;
	padding: 7px 12px;
	cursor: pointer;
	transition: background-color 0.15s ease;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%) scaleY(0);
		width: 3px;
		height: 24px;
		border-radius: 0 2px 2px 0;
		background: var(--im-session-indicator);
		transition: transform 0.2s ease;
	}

	&:hover {
		background-color: rgba(var(--im-primary-rgb), 0.04);
	}

	&.active {
		background-color: rgba(var(--im-primary-rgb), 0.09);

		&::before { transform: translateY(-50%) scaleY(1); }

		.friend-name-text {
			color: var(--im-session-text);
			font-weight: 600;
		}
	}

	&.small {
		height: 42px;
		padding: 4px 10px;
	}

	.friend-avatar {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.friend-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.friend-name {
			display: flex;
			align-items: center;
			gap: 6px;
			
			.friend-name-text {
				font-size: 14px;
				font-weight: 500;
				line-height: 20px;
				color: var(--im-session-text);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

		}
	}
}
</style>
